import React from 'react';
import { LegalLayout, LegalBlock } from './LegalLayout';
import { useLanguage } from '../../i18n/LanguageContext';
export function PoliticaCookies() {
  const {
    lang
  } = useLanguage();
  const es = lang === 'es';
  return <LegalLayout titleEs="Política de Cookies" titleCa="Política de Cookies" subtitleEs="Información sobre el uso de cookies en este sitio Web" subtitleCa="Informació sobre l'ús de cookies en aquest lloc web" data-id="element-586">
      {/* BLOCK 1 */}
      <LegalBlock title={es ? '¿Qué son las cookies?' : 'Què són les cookies?'} data-id="element-587">
        {es ? <>
            <p data-id="element-588">
              Una cookie es un fichero que se descarga en tu dispositivo al
              acceder a determinadas páginas web.
            </p>
            <p data-id="element-589">
              Las cookies permiten al sitio web almacenar y recuperar
              información sobre los hábitos de navegación del usuario.
              Dependiendo de la información que contengan, pueden utilizarse
              para reconocer al usuario.
            </p>
          </> : <>
            <p data-id="element-590">
              Una cookie és un fitxer que es descarrega al teu dispositiu en
              accedir a determinades pàgines web.
            </p>
            <p data-id="element-591">
              Les cookies permeten al lloc web emmagatzemar i recuperar
              informació sobre els hàbits de navegació de l'usuari. Depenent de
              la informació que continguin, poden utilitzar-se per reconèixer
              l'usuari.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 2 — Cards */}
      <LegalBlock title={es ? 'Tipos de Cookies que Utilizamos' : 'Tipus de Cookies que Utilitzem'} data-id="element-592">
        <div className="grid sm:grid-cols-2 gap-4 mt-2" data-id="element-593">
          <div className="bg-[#1a3a2a] text-cream rounded-lg p-5" data-id="element-594">
            <div className="text-3xl mb-3" data-id="element-595">📊</div>
            <h3 className="font-serif text-xl text-gold-light mb-2" data-id="element-596">
              {es ? 'Cookies de Análisis' : "Cookies d'Anàlisi"}
            </h3>
            <p className="text-[14px] text-cream/85 leading-relaxed" data-id="element-597">
              {es ? 'Nos permiten cuantificar el número de usuarios y realizar análisis estadístico de la utilización del servicio. Analizamos la navegación en nuestra web para mejorar la oferta de servicios.' : "Ens permeten quantificar el nombre d'usuaris i realitzar anàlisis estadístiques de la utilització del servei. Analitzem la navegació a la nostra web per millorar l'oferta de serveis."}
            </p>
          </div>
          <div className="bg-[#8a9e7a] text-cream rounded-lg p-5" data-id="element-598">
            <div className="text-3xl mb-3" data-id="element-599">📢</div>
            <h3 className="font-serif text-xl text-cream mb-2" data-id="element-600">
              {es ? 'Cookies Publicitarias' : 'Cookies Publicitàries'}
            </h3>
            <p className="text-[14px] text-cream/95 leading-relaxed" data-id="element-601">
              {es ? 'Nos permiten gestionar los espacios publicitarios adecuando el contenido al uso que haces del sitio. Podemos mostrarte publicidad relacionada con tu perfil de navegación.' : "Ens permeten gestionar els espais publicitaris adequant el contingut a l'ús que fas del lloc. Podem mostrar-te publicitat relacionada amb el teu perfil de navegació."}
            </p>
          </div>
        </div>
      </LegalBlock>

      {/* BLOCK 3 */}
      <LegalBlock title={es ? '¿Cómo Desactivar las Cookies?' : 'Com Desactivar les Cookies?'} data-id="element-602">
        <p data-id="element-603">
          {es ? 'Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo desde la configuración de tu navegador:' : 'Pots permetre, bloquejar o eliminar les cookies instal·lades al teu equip des de la configuració del teu navegador:'}
        </p>
        <p data-id="element-604">
          {es ? 'Accede a la configuración de tu navegador:' : 'Accedeix a la configuració del teu navegador:'}
        </p>
        <div className="flex flex-wrap gap-3 mt-3" data-id="element-605">
          {[{
          icon: '🦊',
          label: 'Firefox',
          href: 'https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias'
        }, {
          icon: '🧭',
          label: 'Safari',
          href: 'https://support.apple.com/es-es/HT201265'
        }, {
          icon: '🌐',
          label: 'Chrome',
          href: 'https://support.google.com/chrome/answer/95647?hl=es'
        }].map(b => <a key={b.label} href={b.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 border-2 border-[#c49a4a] text-[#1a3a2a] rounded-full hover:bg-[#c49a4a] hover:text-white transition-colors text-[14px] font-medium" data-id="element-606">
              <span data-id="element-607">{b.icon}</span>
              <span data-id="element-608">{b.label}</span>
            </a>)}
        </div>
      </LegalBlock>

      {/* BLOCK 4 */}
      <LegalBlock title={es ? 'Cookies de Terceros' : 'Cookies de Tercers'} data-id="element-609">
        {es ? <>
            <p data-id="element-610">
              Este sitio Web utiliza servicios de terceros para recopilar
              información con fines estadísticos y de mejora del servicio.
            </p>
            <p data-id="element-611">
              Al continuar navegando en este sitio Web, aceptas el uso de
              cookies según lo descrito en esta política.
            </p>
            <p data-id="element-612">
              Si no estás de acuerdo, puedes configurar tu navegador para
              rechazar las cookies o recibir un aviso cuando se envíen.
            </p>
          </> : <>
            <p data-id="element-613">
              Aquest lloc web utilitza serveis de tercers per recopilar
              informació amb finalitats estadístiques i de millora del servei.
            </p>
            <p data-id="element-614">
              En continuar navegant en aquest lloc web, acceptes l'ús de cookies
              segons el que es descriu en aquesta política.
            </p>
            <p data-id="element-615">
              Si no hi estàs d'acord, pots configurar el teu navegador per
              rebutjar les cookies o rebre un avís quan s'enviïn.
            </p>
          </>}
      </LegalBlock>
    </LegalLayout>;
}